// Application.tsx
import React, { useState } from 'react';

const ColorInput: React.FC<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }) => {

  const [color, setColor] = useState<string>(value);
  const [oldColor, setOldColor] = useState<string>(value);
  const [active, setActive] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOldColor(color);
    setColor(e.target.value);
    setActive((prev) => !prev);
    onChange(e.target.value);
  };

  return (
    <div
      className="background-color"
    >
      <div
        className={active ? 'overlay-color active' : 'overlay-color'}
        style={{ 
            background: active ? color : oldColor
        }}
      />
      <label className="color-selector-color" style={{
        border: '1px solid #e4e6eb'
      }}>
        <span className="circle-color" style={{ background: color }} />
        <span>{color}</span>
        <input
          type="color"
          value={color}
          onChange={handleChange}
          className="hidden-color"
        />
      </label>
    </div>
  );
};

export default ColorInput;
